import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchSGGamesData, fetchSgPolasData } from '../../store/actions/sgGameAction';
import Loading from '../Loading';

const SpadeGamingCard = (data) => {
  const dispatch = useDispatch();
  const { sgNames, sgImages, sgPolas, nameAndImagesIsLoading } = useSelector((state) => state.sgGameReducer);

  useEffect(() => {
    dispatch(fetchSgPolasData());
    dispatch(fetchSGGamesData());
  }, [dispatch]);

  if (data.isLoading || nameAndImagesIsLoading) return (
    <>
      <Loading />
    </>
  )

  return (
    <>
      <h2>Spadegaming</h2>
      <section className="container px-3 sm:px-12 mx-auto" id="jg">
        <div className='grid grid-cols-2 lg:grid-cols-6 gap-4 justify-items-center'>
          {
            sgNames.map((sgName, i) => {
              return (
                <div key={i} className="w-full grid justify-items-center bg-item p-3">
                  <div className="relative flex-shrink-0">
                    <img width={"150px"} src={sgImages[i]} alt={sgName} />
                  </div>
                  <div className="grid box-content text-center content-center capitalize mb-3">
                    <span className="game-name h-12 grid content-center">{sgName}</span>
                    <div className="jam px-5 py-3 mb-3">
                      <span>Jam Gacor: </span>
                      <span className="jamGacor">
                        {data.jamGacors[i] ? data.jamGacors[i].value5 : ''}
                      </span>
                    </div>
                    <span>Pola: </span>
                    <span className="v">{sgPolas[i] ? `${sgPolas[i].value1} - ${sgPolas[i].value2} - ${sgPolas[i].value3}` : ''}</span>
                  </div>
                  <div className='single-bar relative items-center'>
                    <div className='absolute font-bold rtpValue' style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <span>{data.rtps[i] ? data.rtps[i].value5 : ''}%</span>
                    </div>
                    <div className="single-bar__fill bar animated-gradient" style={{ width: `${data.rtps[i] ? data.rtps[i].value5 : ''}%` }}></div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </section >
    </>
  );
};

export default SpadeGamingCard;